<template>
  <v-col
    cols="12"
    :class="'footer-text white mt-n5 ' + (!$vuetify.breakpoint.mdAndUp ? '' : 'px-1')"
  >
    <v-container
      :class="'pt-0 text-left ' + (!$vuetify.breakpoint.mdAndUp ? '' : 'px-0')"
    >
      <v-row dense :class="(!$vuetify.breakpoint.mdAndUp ? '' : '')">
        <v-col
          :cols="$vuetify.breakpoint.mdAndUp ? 8 : 12"
          :order="$vuetify.breakpoint.mdAndUp ? 1 : 2"
          class="pt-2"
        >
          {{ $i18n.t('footerMessage') }}
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12"
          :order="$vuetify.breakpoint.mdAndUp ? 2 : 1"
          style="font-size: 26px;"
          class="text-right"
        >
          <i class="fab fa-cc-visa ml-2"></i>
          <i class="fab fa-cc-mastercard ml-2"></i>
          <i class="fab fa-cc-apple-pay ml-2"></i>
          <i class="fab fa-cc-amex ml-2"></i>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import moment from 'moment'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'PageFooter',

  data () {
    return {
      originalWidth: window.innerWidth,
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    yearNumber () {
      return moment().format('Y')
    },
  },
}
</script>

<style>
.footer-text {
  color: gray;
}
@media screen and (max-width: 700px) {
  .footer-text {
    font-size: 11px;
  }
}
</style>
